import { ElementController } from 'js-common';

import { PAGE_SPINNER_CONTROLLER_ID } from './constants';

export const PAGE_SPINNER_EVENT = {
  show: 'pageSpinner:show',
  completed: 'pageSpinner:completed',
  hide: 'pageSpinner:hide',
};

const THEME_CLASS_NAME_PREFIX = 'theme--';

/**
 * Controller for a full page spinner taking up whole screen.
 */
export default class PageSpinner extends ElementController {
  static id = PAGE_SPINNER_CONTROLLER_ID;

  /**
   * DOM ready.
   */
  init() {
    this.loadingText = this.selectSingle('loading-text');
    this.completedText = this.selectSingle('completed-text');
    this.spinner = this.selectSingle('spinner');
    this.closeBtn = this.selectSingle('close-btn');

    // React to global show event
    this.onGlobal(PAGE_SPINNER_EVENT.show, this._handleGlobalShow);

    // React to global completed event
    this.onGlobal(PAGE_SPINNER_EVENT.completed, this._handleGlobalCompleted);

    // React to global hide event
    this.onGlobal(PAGE_SPINNER_EVENT.hide, this._handleGlobalHide);

    this.on(this.closeBtn, 'click', this.close);
  }

  /**
   * @param {Event} e - Event
   *  @param {string} loadingText - Modal text when loading
   */
  _handleGlobalShow = (e, loadingText) => {
    this.loadingText.textContent = loadingText;
    this.showLoadingContent();
    this.root.removeAttribute('hidden');
  };

  showCompletedContent() {
    this.loadingText.setAttribute('hidden', '');
    this.spinner.setAttribute('hidden', '');
    this.completedText.removeAttribute('hidden');
    this.closeBtn.removeAttribute('hidden');
    this.removeThemeClass();
  }

  showLoadingContent() {
    this.loadingText.removeAttribute('hidden');
    this.spinner.removeAttribute('hidden');
    this.completedText.setAttribute('hidden', '');
    this.closeBtn.setAttribute('hidden', '');
    this.removeThemeClass();
  }

  removeThemeClass() {
    const prefix = THEME_CLASS_NAME_PREFIX;
    const className = this.root.className
      .split(' ')
      .filter((c) => !c.startsWith(prefix));
    this.root.className = className.join(' ').trim();
  }

  /**
   * @param {Event} e - Event
   *  @param {string} completedText - Modal text when completed
   */
  _handleGlobalCompleted = (e, completedText, theme) => {
    this.showCompletedContent();
    this.completedText.textContent = completedText;
    if (typeof theme !== 'undefined') {
      this.root.classList.add(`${THEME_CLASS_NAME_PREFIX}${theme}`);
    }
  };

  _handleGlobalHide = () => {
    this.root.setAttribute('hidden', '');
  };

  close = () => {
    this.triggerGlobalCustomEvent(PAGE_SPINNER_EVENT.hide);
  };
}
